// Тема оформления — источник истины сервер (personal prefs), но первый кадр красится ещё до
// ответа сети признаком, который уже стоит на документе (index.html выставил его синхронно из
// localStorage-кеша lib/theme.ts — без этого была бы вспышка темы по умолчанию).
import { useEffect, useState } from "react";
import { resolveTheme, applyTheme, isTheme } from "../lib/theme";
import { sharedEventBus } from "../osnovaContext";
export function useTheme(userId) {
    const [theme, setTheme] = useState(() => (isTheme(document.documentElement.dataset.theme) ? document.documentElement.dataset.theme : "dark"));
    useEffect(() => {
        if (!userId)
            return;
        let cancelled = false;
        resolveTheme().then((t) => {
            if (cancelled)
                return;
            applyTheme(t);
            setTheme(t);
        });
        return () => { cancelled = true; };
    }, [userId]);
    // Живая смена темы — продукт «Настройки» пишет её напрямую в PUT /api/prefs (свой прямой
    // путь), ядро узнаёт об этом через installPrefsBridge()+sharedEventBus, без перезагрузки.
    useEffect(() => {
        return sharedEventBus.on("platform:prefs", (data) => {
            const change = data;
            if (change?.key !== "theme" || !isTheme(change.value))
                return;
            applyTheme(change.value);
            setTheme(change.value);
        });
    }, []);
    return { theme };
}
